import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  setSearchTerm({ commit }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({ commit }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setSortDir({ commit }, sortDir) {
    commit(types.SET_SORT_DIR, sortDir)
  },
  setOrderBy({ commit }, orderBy) {
    commit(types.SET_ORDER_BY, orderBy)
  },
  setFilterBy({ commit }, filterBy) {
    commit(types.SET_FILTER_BY, filterBy)
  },
  setFilterOptions({ commit }, data) {
    commit(types.SET_FILTER_OPTIONS, data)
  },
  initAdas({ commit }, data) {
    commit(types.INIT_ADAS, data)
  },
  initAdasInspection({ commit }, data) {
    commit(types.INIT_ADASINSPECTION, data)
  },
  updateAdas({ commit }, data) {
    commit(types.UPDATE_ADAS, data)
  },
  updateAdasInspection({ commit }, data) {
    commit(types.UPDATE_ADASINSPECTION, data)
  },
  async getAdass({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getAdass', () =>
      http.get('adas/adass', {
        params: searchOptions
      })
    )
    commit(types.SET_ADASS, r.data)
    return r.data
  },
  async getAdas({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getAdas', () =>
      http.get(`adas/adas?adas=${id}`)
    )
    commit(types.SET_ADAS, r.data)
    return r.data
  },
  async createAdas({ commit, state, dispatch }, data) {
    const r = await startLoading(dispatch, 'createAdas', () =>
      http.post('adas/createAdas', data)
    )
    return r.data
  },
  async saveAdas({ commit, state, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveAdas', () =>
      http.post('adas/saveAdas', data)
    )
    return r.data
  },
  async saveAdasInspection({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveAdasInspection', () =>
      http.post('adas/saveAdasInspection', data)
    )
    commit(types.UPDATE_ADAS_INSPECTION_RECORD, data)
    return r.data
  },
  async getAdasInspections({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getAdasInspections', () =>
      http.get(`adas/adasInspections?adas=${id}`)
    )
    commit(types.SET_ADASINSPECTIONS, r.data)
    return r.data
  },
  async getAdasInspection({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getAdasInspection', () =>
      http.get(`adas/adasInspection?adasInspection=${id}`)
    )
    commit(types.SET_ADASINSPECTION, r.data)
    return r.data
  },
  async deleteAdasInspection({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'deleteAdasInspection', () =>
      http.post('adas/deleteInspection', data)
    )
    return r.data
  },
  async getAdasInspectionItems({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getAdasInspectionItems', () =>
      http.get(`adas/adasInspectionItems?adasInspection=${id}`)
    )
    commit(types.SET_ADASINSPECTIONITEMS, r.data)
    return r.data
  },
  async getAdasInspectionResults({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getAdasInspectionResults', () =>
      http.get(`adas/adasInspectionResults?adasInspection=${id}`)
    )
    commit(types.SET_ADASINSPECTIONRESULTS, r.data)
    return r.data
  },
  async saveAdasInspectionResults({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveAdasInspectionResults', () =>
      http.post('adas/saveAdasInspectionResults', data)
    )
    return r.data
  },
  async sendReport({ commit, dispatch }, report) {
    const r = await startLoading(dispatch, 'sendReport', () =>
      http.get(`report/send${report.report}?adasInspection=${report.adasInspection}`)
    )
    return r.data
  },
  async getReportPreference({ commit, dispatch }, adasInspection) {
    const r = await startLoading(dispatch, 'getReportPreference', () =>
      http.get(`report/reportPreference?adasInspection=${adasInspection}`)
    )
    commit(types.SET_REPORTPREFERENCE, r.data)
    return r.data
  },
  async updateStatusAdas({ commit, dispatch }, status) {
    const r = await startLoading(dispatch, 'updateStatusAdas', () =>
      http.post('adas/updateStatusAdas', status)
    )
    commit(types.SET_ADAS_STATUS, status)
    return r.data
  },
  async updateStatusAdasInspection({ commit, dispatch }, status) {
    const r = await startLoading(dispatch, 'updateStatusAdasInspection', () =>
      http.post('adas/updateStatusAdasInspection', status)
    )
    commit(types.SET_ADAS_INSPECTION_STATUS, status)
    return r.data
  },
  async resetDecodedAdas({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'resetDecodedAdas', () =>
      http.post('adas/decode', data)
    )
    commit(types.SET_ADAS_RESET, r.data)
    return r.data
  },
  async getLinks({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getLinks', () =>
      http.get('alldata/getLinks', {
        params: data
      })
    )
    commit(types.SET_LINKS, r.data)
    return r.data
  },
  async getGeneralInfoLinks({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getLinks', () =>
      http.get('alldata/getGeneralInfoLinks', {
        params: data
      })
    )
    commit(types.SET_LINKS, r.data)
    return r.data
  },
  async getAdasChecklistMappedToDecoded({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getAdasChecklistMappedToDecoded', () =>
      http.get(`admin/getAdasChecklistMappedToDecoded?id=${id}`)
    )
    commit(types.SET_DECODED, r.data)
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/adas/actions.js